import { Button, Grid, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks/hooks';
import { getPartnerId, getServicingOpCo, getZipCode } from '../../../app/store/combinedSelectors';
import { backBtn } from '../../../Constants/Constants';
import getCopyById from '../../../copy/copyMapper';
import { ProviderInfo, SearchContext, StageNames } from '../../../types/type';
import { getStagesInOrder } from '../../../utils/Utilities';
import ServiceError, { SERVICE_TYPE } from '../../shared/ServiceErrorScreen/ServiceError';
import StepProgressBar from '../../shared/StepProgressBar/StepProgressBar';
import Search from '../Search/Search';
export default function RentalServiceSelection() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [serviceError, setServiceError] = React.useState(false);
  const claimSummary = useAppSelector((state) => state.claimDetail.claimSummary);
  let zipCode = useSelector(getZipCode);
  const opco = useSelector(getServicingOpCo);
  const partnerId = useSelector(getPartnerId);
  const copy = getCopyById(opco, partnerId);

  // If the zip code is not present in validate call response, fallback to the one which is in claim details response
  if (!zipCode) {
    zipCode = claimSummary?.lossLocationAddress.postalCode;
  }

  const availableProgressStages = useAppSelector((state) => state.services.availableProgressStages);
  const currentStage = availableProgressStages.filter((stage) => stage.viewActive === true);

  // Get the rest of stages excluding the current stage. Find the next stage which is valid
  const nextStage = getStagesInOrder(
    availableProgressStages.filter(
      (stage) => stage.id !== currentStage[0].id && !stage.completed && stage.isEligible && !stage.skipped
    )
  )[0];

  function handleSelection(selectedService: any) {
    // Set Provider Info
    const provider: ProviderInfo = {
      serviceTypeName: StageNames.RENTAL,
      serviceAvailable: 'available',
      providerName: selectedService.name,
      providerPhone: selectedService.contactMethodDetail.primaryPhoneNumber,
      providerAddress:
        selectedService.address.addressLine1 +
        ' ' +
        selectedService.address.city +
        ', ' +
        selectedService.address.state +
        ' ' +
        selectedService.address.zipCode,
      providerID: selectedService.id,
    };

    navigate('/rental-finalize', {
      state: {
        provider: provider,
      },
    });
  }

  let content = <div></div>;
  if (!serviceError) {
    content = (
      <Box sx={{ width: '100%' }}>
        <StepProgressBar stateInfo={availableProgressStages}></StepProgressBar>

        <Search copy={copy} locationSelection={handleSelection} opcoId={''} searchContext={SearchContext.RENTAL} />

        <Grid
          sx={{
            marginTop: '2em',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'flex-start',
            p: '1rem',
          }}
          item
          xs={12}
        >
          <Button
            sx={{
              ...theme.custom.styles.genericSecondaryButton,
            }}
            onClick={() => navigate(-1)}
          >
            {backBtn}
          </Button>
        </Grid>
      </Box>
    );
  } else {
    content = (
      <Box sx={{ width: '100%' }}>
        {/* Show Progress bar only if there is no service error */}
        {!serviceError && <StepProgressBar stateInfo={availableProgressStages}></StepProgressBar>}
        {serviceError && <ServiceError serviceType={SERVICE_TYPE.RENTAL_AGENCY} />}
      </Box>
    );
  }
  return <Box sx={{ width: '100%' }}>{content}</Box>;
}
